<template>
  <div class="row content">
    <div 
      class="summary well small col-md-12 "
      :class="snapshotClass">
      <table class="col-md-12 mb-5" v-if="!isP2PInvoice">
        <thead>
          <tr>
            <td>Approved Budget</td>
            <td>Invoiced</td>
            <td v-if="showVATCondition">VAT/GST</td>
            <td v-if="model.ShowExpenses">Expenses</td>
            <td>Remaining Budget</td>
          </tr>
        </thead>
        <tfoot>
          <tr>
            <td>Approved Budget</td>
            <td>Invoiced</td>
            <td v-if="showVATCondition">VAT/GST</td>
            <td v-if="model.ShowExpenses">Expenses</td>
            <td>Remaining Budget</td>
          </tr>
        </tfoot>
        <tbody>
          <tr>
            <td>
              <v-money name='program_budget'>{{ model.ProgramBudget }}</v-money>
            </td>
            <td>
              <v-money name='current_invoiced_amount'>{{ model.CurrentInvoicedAmount }}</v-money>
            </td>
            <td v-if="showVATCondition">
              <v-money name='vat_allocation'>{{ model.CurrentVatGstAmount + (model.IncludeExpenseInBudget ? model.TotalVatGstOnExpense : 0) }}</v-money>
            </td>
            <td v-if="model.ShowExpenses">
              <v-money name='expense_amount'>{{ model.ExpenseAmount }}</v-money>
            </td>
            <td>
              <v-money name='budget_balance'>{{ model.BudgetBalance }}</v-money>
            </td>
          </tr>
        </tbody>
      </table>

      <table class="col-md-12 mb-5" v-else>
        <thead>
          <tr>
            <td>Total PO</td>
            <td>Total Invoiced amount</td>
            <td>Received Payments</td>
            <td>Scheduled Payments</td>
            <td>PO Outstanding Balance</td>
          </tr>
        </thead>
        <tfoot>
          <tr>
            <td>Total PO</td>
            <td>Total Invoiced amount</td>
            <td>Received Payments</td>
            <td>Scheduled Payments</td>
            <td>PO Outstanding Balance</td>
          </tr>
        </tfoot>
        <tbody>
          <tr>
            <td>
              <v-money name='po_total_amount'>{{ model.TotalAmount }}</v-money>
            </td>
            <td>
              <v-money name='po_total_invoice_amount'>{{ model.TotalInvoiceAmount }}</v-money>
            </td>
            <td>
              <v-money name='po_received_amount'>{{ model.ReceivedAmount }}</v-money>
            </td>
            <td>
              <v-money :currency="currency" name='po_total_unprocessed'>{{ model.TotalUnprocessed }}</v-money>
            </td>
            <td>  
              <v-money :currency="currency" name='po_balance'>{{ model.POBalance }}</v-money>
            </td>
          </tr>
        </tbody>
      </table>
      <ed-notice v-if='displayNotice' :type="'warn'" class="program-spend-widget__notice" icon="fas fa-exclamation-triangle">
        {{noticeMsg}}
      </ed-notice>
      <div class="clear" />
    </div>
  </div>
</template>

<script>
  /* eslint spec-file: 0 */
  import { EventBus } from '@/event-bus'
  import LineItemStore from './dialogs/LineItem/LineItemStore.js'
  import Events from '@/core/events/events'

  export default {
    props: {
      model: Object,
      sectionClass: String
    },

    data() {
      return {
        originalCurrentInvoicedAmount: 0,
        originalCurrentVatGstAmount: 0,
        originalBudgetBalance: 0,
        originalDataIsInitialised: false,
        budgetBalanceInitialSet: false
      }
    },

    created() {
      this.initialiseData()

      EventBus.$off(Events.I2P.UPDATE_SNAPSHOT)
      EventBus.$on(Events.I2P.UPDATE_SNAPSHOT, this.updateSnapshot)

      EventBus.$off(Events.I2P.UPDATE_P2P_Snapshot)
      EventBus.$on(Events.I2P.UPDATE_P2P_Snapshot, this.updateP2PSnapshot)
    },

    computed: {
      currency() {
        return this.model.POCurrencyCode || this.model.ProgramCurrencyCode
      },
      showVATCondition() {
        return (!this.model.useHighLevelAllocation && this.model.ExcludeVATFromBudget) ||
        (this.model.useHighLevelAllocation && this.model.ExcludeVATFromBudget && this.model.ShowVatAllocation)
      },
      isP2PInvoice() {
        return this.model.InvoiceWorkflow && this.model.InvoiceWorkflow.indexOf('P2PInvoice') !== -1
      },
      snapshotClass() {
        let hiddenClass = ''
        if (!this.model.ProgramIsSelected) {
          hiddenClass += 'hidden'
        }
        return hiddenClass
      },
      budgetBalancePercent() {
        return this.model.BudgetBalance <= 0 ? 0 : (this.model.BudgetBalance * 100 / this.model.ProgramBudget)
      },
      displayNotice() {
        return !this.isP2PInvoice && this.budgetBalancePercent < 20
      },
      noticeMsg() {
        let programLabel = global.app.$user.sessionSettings.CompanySettings.ProgramLabel
        if (this.model.BudgetBalance < 0) return programLabel + ' is over budget.'
        return this.budgetBalancePercent < 20
          ? Math.ceil(this.budgetBalancePercent).toFixed(0) + '% of ' + programLabel.toLowerCase() + ' budget remains.'
          : ''
      }
    },

    methods: {
      store() {
        return new LineItemStore(this.api)
      },

      updateSnapshot(e) {
        // this.setInitialBudgetSnapshot()

        let sentCurrencyCode = e && e.data && e.data.programCurrencyCode
        if (sentCurrencyCode) {
          this.model.ProgramCurrencyCode = sentCurrencyCode
        }
        var programCurrency = this.model.ProgramCurrencyCode

        if (programCurrency && this.model.InvoiceCurrencyCode) {
          if (this.mustInitOnEditMode() && e.data.isP2PWorkflow) {
            this.initP2PData()
          }
          if (this.mustInitOnEditMode()) {
            this.initDataOnEditAndUpdateSnapshot(e.data, programCurrency, this.model.InvoiceCurrencyCode, this.model.OriginalInvoiceCurrencyCode)
          } else {
            this.updateSnapshotWithCurrencyChecks(e.data, programCurrency)
          }
        }
      },

      initP2PData(data) {
        this.model.initDataForEdit = false
        this.updateOriginals(0, 0)
      },

      updateSnapshotWithCurrencyChecks(data, programCurrency) {
        // if the invoice and the program have the same currency, we do not need to convert amounts
        if (programCurrency === this.model.InvoiceCurrencyCode &&
            (
              !this.model.OriginalInvoiceCurrencyCode ||
              (this.model.OriginalInvoiceCurrencyCode && this.model.OriginalInvoiceCurrencyCode === this.model.InvoiceCurrencyCode))
            ) {
          this.updateSnapshotSameCurrency(data)
        } else {
          // make currency conversion
          this.updateSnapshotDifferenctCurrency(data)
        }
      },

      updateSnapshotSameCurrency(data) {
        var totalVATGST = (this.model.ExcludeVATFromBudget && data.totalVATGST) ? +data.totalVATGST : 0
        var totalLessVatGst = +data.total - totalVATGST
        this.updateSnapshotItems(totalVATGST, totalLessVatGst)
      },

      updateSnapshotDifferenctCurrency(data) {
        var totalVATGST = 0
        var total = 0
        var totalLessVatGst = 0

        this.store().GetInvoiceTotalAmount(
          data.total ? +data.total : 0,
          data.totalVATGST ? +data.totalVATGST : 0,
          this.model.InvoiceCurrencyCode,
          this.model.ProgramCurrencyCode
        )
        .then(response => {
          let data = JSON.parse(response.data.Data)

          totalVATGST = (this.model.ExcludeVATFromBudget && data.VatAmount) ? data.VatAmount : 0
          total = data.InvoiceAmount
          totalLessVatGst = total - totalVATGST

          this.updateSnapshotItems(totalVATGST, totalLessVatGst)
        })
      },

      updateSnapshotItems(totalVATGST, totalLessVatGst) {
        this.model.CurrentInvoicedAmount = +this.originalCurrentInvoicedAmount + totalLessVatGst
        this.model.CurrentVatGstAmount = +this.originalCurrentVatGstAmount + totalVATGST

        this.model.BudgetBalance = +this.originalBudgetBalance - totalLessVatGst // - (this.model.ExcludeVATFromBudget ? this.model.CurrentVatGstAmount : 0)
        // in case of HighLevelAllocation workflow we need to substract also CurrentVatGstAmount because it is already included in TotalAmount
      },

      mustInitOnEditMode() {
        return this.model.initDataForEdit && this.model.initDataForEdit.toString() === 'true'
      },

      initialiseData() {
        this.originalCurrentInvoicedAmount = this.model.CurrentInvoicedAmount
        this.originalCurrentVatGstAmount = this.model.CurrentVatGstAmount
        this.originalBudgetBalance = this.model.BudgetBalance
      },

      initDataOnEditAndUpdateSnapshot(data, programCurrency, invoiceCurrency, originalCurrency) {
        this.model.initDataForEdit = false

        // init data on Edit when we have different currencies
        if (programCurrency !== invoiceCurrency || (originalCurrency && invoiceCurrency !== originalCurrency)) {
          var totalAmount = 0
          var totalVATGST = 0
          var totalLessVatGst = 0

          this.store().GetInvoiceTotalAmount(
            data.total ? +data.total : 0,
            data.totalVATGST ? +data.totalVATGST : 0,
            invoiceCurrency,
            programCurrency
          )
          .then(response => {
            let responseData = JSON.parse(response.data.Data)

            totalAmount = +responseData.InvoiceAmount
            totalVATGST = (this.model.ExcludeVATFromBudget && +responseData.VatAmount) ? +responseData.VatAmount : 0
            totalLessVatGst = totalAmount - totalVATGST

            this.updateOriginals(totalVATGST, totalLessVatGst)

            this.updateSnapshotWithCurrencyChecks(data, programCurrency)
          })
        } else {
          // init data on Edit when we have same currencies
          totalAmount = +data.total
          totalVATGST = this.model.ExcludeVATFromBudget && data.totalVATGST ? +data.totalVATGST : 0
          totalLessVatGst = totalAmount - totalVATGST

          this.updateOriginals(totalVATGST, totalLessVatGst)
        }
      },

      updateOriginals(totalVATGST, totalLessVatGst) {
        this.originalCurrentInvoicedAmount = this.model.CurrentInvoicedAmount - totalLessVatGst
        this.originalCurrentVatGstAmount = this.model.CurrentVatGstAmount - totalVATGST
        this.originalBudgetBalance = this.model.BudgetBalance + totalLessVatGst

        // this.setHighLevelBudgetBalance()
      },

      /* setInitialBudgetSnapshot() {
        if (!this.model.InvoiceCurrencyCode) {
          this.setHighLevelBudgetBalance()
          this.budgetBalanceInitialSet = true
        } else {
          if (this.budgetBalanceInitialSet) {
            this.unSetHighLevelBudgetBalance()
            this.budgetBalanceInitialSet = false
          }
        }
      },

      setHighLevelBudgetBalance() {
        if (this.vatHighLevelCondition()) {
          this.model.BudgetBalance -= this.model.CurrentVatGstAmount
        }
      },

      unSetHighLevelBudgetBalance() {
        if (this.vatHighLevelCondition()) {
          this.model.BudgetBalance += this.model.CurrentVatGstAmount
        }
      },

      vatHighLevelCondition() {
        return this.model.useHighLevelAllocation && this.showVATCondition
      },

      reduceVatFromBudgetBalance() {
        return this.model.useHighLevelAllocation && this.model.ExcludeVATFromBudget
      }, */

      updateP2PSnapshot(e) {
        this.model.POCurrencyCode = e.data.CurrencyCode
        this.model.TotalAmount = e.data.TotalAmount
        this.model.TotalInvoiceAmount = e.data.TotalInvoiceAmount
        this.model.ReceivedAmount = e.data.ReceivedAmount
        this.model.TotalUnprocessed = e.data.TotalUnprocessed
        this.model.POBalance = e.data.Balance
      }
    }
  }

</script>

<style scoped lang='scss'>
  @import "~@/assets/sass/_variables.scss";
  @mixin soft-font {
    transform: rotate(.03deg); // soften font a bit
  }
  
  .snapshot {
    @include theme {
    }
    &.striped .field {
      &:nth-of-type(odd) {
        @include theme {
          background: v(canvas);
        }
      }
      &.field {
        border: none;
      }
    }
    .field {
      padding-left: 1em;
      padding-right: 1em;
      line-height: 1.5em;
      @include theme {
        border-top: 1px solid v(background);
      }
      &.header {
        @include theme {
          background: v(background-light);
        }
      }
      &.footer-line {
        @include theme {
          border-bottom: 1px solid v(background);
        }
      }
      &.field.footer {
        @include theme {
          background: v(ink);
        }
        .value {
          font-size: $font-size-base-lg;
        }
      }
      label {
        @include soft-font;
        font-size: $font-size-base-sm;
        text-transform: uppercase;
        margin: 0;
      }
      .value {
        @include soft-font;
        display: inline-block;
        font-size: $font-size-base-sm;
        float: right;
      }
    }
  }
  
  // Section cards or containers
  .summary {
    &.well .dawn-notification {
      min-height: 2em;

      >>> .icon-wrapper {
        line-height: unset;
      }
    }
    &.well {
      @include theme {
      background: v(canvas);
      border-color: v(background);
      }
      border-radius: 0;
      box-shadow: none;
      padding: .7em 1.5em;
    }
    thead, tfoot {
      font-size: $font-size-xsmall;
    }
    thead {
      display: none;
    }
    tfoot {
      @include theme {
      color: v(background);
      }
    }
    tbody {
      font-weight: $font-weight-bold;
      font-size: $font-size-base-lg;
    }
    td {
      &:first-child {
        padding-left: 0;
      }
      padding-left: 2.33333333%;
    }
  }
  .well {
    border-radius: 0;
    padding-top: .8em;
    padding-bottom: .6em;
    box-shadow: none;
    @include theme {
    border-color: v(background);
    }
    margin-bottom: 10px;

    .expand-icon {
      line-height: 1.7em;
    }

    label {
      @include soft-font;
    }
  }
  .mb-5 {
    margin-bottom: 5px;
  }   
</style>



// WEBPACK FOOTER //
// src/components/_modules/I2P/BudgetSnapshot.vue